import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const TimeIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={19}
      height={18}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M10.25 4a.75.75 0 00-1.5 0v5a.75.75 0 00.352.636l3 1.875a.75.75 0 10.796-1.272L10.25 8.584V4z"
        fill={tintColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM2.25 9a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default TimeIcon;
